<template>
  <div class="w-full height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Product Details
          </h2>
        </div>
      </div>
    </div>
    <div class="flex fixed-top bg-white p-6">
      <div class="w-2/3">
        <div class="pr-8">
          <div class="relative">
            <small class="fsize12 bg-white text-dark">Product Name</small>
            <el-input
              placeholder="Enter or Type..."
              class="rounded-xl mt-2"
              v-model="productName"
            />
          </div>
          <!-- <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item
              title="Product Details"
              class="mt-6 collapse-cs"
              name="1"
            >
              <div class="bg-f4f5f6 p-4 rounded-b-12px">
                <div>
                  <small class="fsize12 text-dark font-medium">Tags</small>
                  <el-select
                    v-model="value"
                    placeholder="Enter or Type..."
                    class="w-full mt-2"
                  >
                    <el-option
                      v-for="item in tagOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="mt-4">
                  <small class="fsize12 text-dark font-medium">Category</small>
                  <el-select
                    v-model="value"
                    placeholder="Enter or Type..."
                    class="w-full mt-2"
                  >
                    <el-option
                      v-for="item in categoryOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="mt-4">
                  <small class="fsize12 text-dark font-medium">Sub-Category</small>
                  <el-select
                    v-model="value"
                    placeholder="Enter or Type..."
                    class="w-full mt-2"
                  >
                    <el-option
                      v-for="item in subcategoryOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse> -->

          <div class="mt-4">
            <small class="fsize12 text-dark font-medium">Tag</small>
            <el-select
              v-model="tagName"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="Enter or Type..."
              :remote-method="remoteMethod"
              :loading="loading"
              class="mt-2"
            >
              <el-option
                v-for="item in tagsDetails"
                :key="item.tagName"
                :label="item.tagName"
                :value="item.tagName"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-10">
            <div class="w-full">
              <h3 class="text-4f4f4f text-xl font-semibold mb-0">
                Add Product Description
              </h3>
              <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
                State some unique selling points
              </p>
            </div>

            <div class="relative mt-3">
              <small class="fsize12 bg-white text-dark font-medium"
                >Description</small
              >
              <el-input
                type="textarea"
                class="mt-2"
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="Description"
                v-model="productDescription"
              >
              </el-input>
            </div>
          </div>
          <div class="mt-10 w-3/4">
            <div class="w-full">
              <h3 class="text-4f4f4f text-xl font-semibold mb-0">
                Product Variations
              </h3>
              <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
                Mix and match attributes and create different variations of this
                product with pricing.<br />
                The first attribute selected will be the primary attribute.
              </p>
            </div>

            <div class="mt-4">
              <small class="fsize12 text-dark font-medium"
                >Primary Attributes</small
              >
              <el-select
                filterable
                remote
                reserve-keyword
                allow-create
                default-first-option
                v-model="primaryAttribute"
                placeholder="Enter or Select..."
                class="w-full mt-2"
              >
                <el-option
                  class="option-bgchange"
                  v-for="item in EcomAttrinutes"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
            <div class="mt-4">
              <small class="fsize12 text-dark font-medium"
                >Secondary Attributes</small
              >
              <el-select
                filterable
                remote
                reserve-keyword
                allow-create
                default-first-option
                v-model="secondaryAttributes"
                placeholder="Enter or Select..."
                class="w-full mt-2"
              >
                <el-option
                  class="option-bgchange"
                  v-for="item in EcomAttrinutes"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="mt-12 w-3/4" v-if="primaryAttribute">
            <div class="flex justify-between">
              <div>
                <h3 class="text-4f4f4f text-xl mb-0">{{ primaryAttribute }}</h3>
                <p class="fsize12 font-medium mb-0 col-8f8f8f">
                  Add photos or graphics to showcase your offerings
                </p>
              </div>

              <p
                class="fill-chips rounded-full fsize12 bg-purple text-white px-8 cursor-pointer py-2"
                @click="addValue"
              >
                Add
              </p>
            </div>
            <div class="mt-4" v-if="showAttributeValue">
              <small class="fsize12 text-dark"
                >Add Primary Attributes Value</small
              >
              <el-select
                multiple
                filterable
                remote
                reserve-keyword
                allow-create
                default-first-option
                v-model="primaryAttributeValue"
                @change="addAttributeValuePrimary"
                placeholder="Enter or Select..."
                class="w-full mt-2"
              >
                <el-option
                  class="option-bgchange"
                  v-for="item in singleAttrinutesPrime.attributeValueId"
                  :key="item.attributeValue"
                  :label="item.attributeValue"
                  :value="item.attributeValue"
                >
                </el-option>
              </el-select>
            </div>
            <div class="mt-8" v-if="datavalue.length > 0">
              <div v-for="items in datavalue" :key="items">
                <div class="flex justify-between">
                  <h3 class="text-4f4f4f text-lg mb-0">{{ items.name }}</h3>
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-6 h-6"
                    class="text-8f8f8f"
                  />
                </div>
                test dataa
                <div class="grid grid-cols-5 gap-6 mt-4">
                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                    v-if="items.images.length < 5"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input
                      type="file"
                      class="choosefilecs"
                      multiple
                      v-on:change="imageUpload($event, items.name)"
                    />
                  </div>

                  <div
                    class="relative"
                    v-for="(item, index) in items.images"
                    :key="item"
                  >
                    <div>
                      <img
                        class="preview h-100px rounded-10px w-full"
                        alt="image"
                        :src="getImages(item)"
                      />
                      {{ item.name }}
                      <div class="absolute topright">
                        <feather-icon
                          icon="XIcon"
                          svgClasses="w-4 h-34"
                          class="cursor-pointer tex-twhite"
                          @click="
                            () => {
                              items.images.splice(index, 1);
                              display();
                            }
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div> -->

                  <!-- <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div> -->
                  <!-- 
                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div> -->
                </div>
              </div>
              <!-- <div class="mt-8">
                <div class="flex justify-between">
                  <h3 class="text-4f4f4f text-lg mb-0">Pink</h3>
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-6 h-6"
                    class="text-8f8f8f"
                  />
                </div>

                <div class="grid grid-cols-5 gap-6 mt-4">
                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>
                </div>
              </div> -->
            </div>
            <div class="mt-8" v-else>
              <div v-for="(items, index) in primaryAttributeValue" :key="items">
                <div class="flex justify-between">
                  <h3 class="text-4f4f4f text-lg mb-0">{{ items }}</h3>
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-6 h-6"
                    class="text-8f8f8f"
                  />
                </div>

                <div class="grid grid-cols-5 gap-6 mt-4">
                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input
                      type="file"
                      class="choosefilecs"
                      multiple
                      v-on:change="imageUpload($event, items)"
                    />
                  </div>

                  <div
                    class="relative"
                    v-for="(item, key) in items.images"
                    :key="key"
                  >
                    <div v-if="items == item.name">
                      <img
                        class="preview h-100px rounded-10px w-full"
                        alt="image"
                        :src="getImages(item)"
                      />{{ item.name }}

                      <div class="absolute topright">
                        <feather-icon
                          icon="XIcon"
                          svgClasses="w-4 h-34"
                          class="cursor-pointer tex-twhite"
                          @click="
                            () => {
                              datavalue.images.splice(index, 1);
                              renderedmultipleImage.splice(index, 1);
                            }
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div> -->

                  <!-- <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div> -->
                  <!-- 
                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div> -->
                </div>
              </div>
              <!-- <div class="mt-8">
                <div class="flex justify-between">
                  <h3 class="text-4f4f4f text-lg mb-0">Pink</h3>
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-6 h-6"
                    class="text-8f8f8f"
                  />
                </div>

                <div class="grid grid-cols-5 gap-6 mt-4">
                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>

                  <div
                    class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
                    <input type="file" class="choosefilecs" />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <b-button
            variant="primary"
            class="rounded-4px bg-purple border-0 text-white font-medium fsize16 py-3 mt-12 sm-fsize14"
            @click="handleSubmit"
          >
            Submit
          </b-button>
        </div>
      </div>
      <div class="w-4/12 pl-8 mt-8">
        <div>
          <!-- <div class="grid grid-cols-2 gap-6">
            <button
              class="py-3"
              :class="[ishowvariant ? 'filledtab' : 'outlinetab']"
              @click="ishowvariant = true"
            >
              Variant
            </button>
            <button
              :class="[!ishowvariant ? 'filledtab' : 'outlinetab']"
              class="py-3"
              @click="ishowvariant = false"
            >
              Add More
            </button>
          </div> -->
          <div class="bg-white rounded-10px py-6 px-4 cust-shadow">
            <div class="">
              <div class="items-center">
                <h1 class="font-semibold col-4f4f4f mb-0 text-xl">
                  Add Variations
                </h1>
                <small class="fsize12 font-medium text-8f8f8f"
                  >Create, edit and delete product variations</small
                >
              </div>
              <div class="mt-4">
                <div>
                  <small class="fsize10 text-dark font-medium">{{
                    primaryAttribute
                  }}</small>
                  <el-select
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    default-first-option
                    v-model="varientAttributeValue"
                    placeholder="Enter or Type..."
                    class="w-full mt-2"
                  >
                    <el-option
                      class="option-bgchange"
                      v-for="item in singleAttrinutesPrime.attributeValueId"
                      :key="item.attributeValue"
                      :label="item.attributeValue"
                      :value="item.attributeValue"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="mt-4">
                  <small class="fsize10 text-dark font-medium">{{
                    secondaryAttributes
                  }}</small>
                  <el-select
                    v-model="Attribute2"
                    multiple
                    placeholder="Enter or Type..."
                    class="w-full mt-2"
                  >
                    <el-option
                      class="option-bgchange"
                      v-for="item in singleAttrinutesSec.attributeValueId"
                      :key="item.attributeValue"
                      :label="item.attributeValue"
                      :value="item.attributeValue"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="mt-4">
                  <small class="fsize10 text-dark font-medium">Pricing</small>

                  <div class="relative">
                    <el-input
                      placeholder="Pricing"
                      class="rounded-xl mt-2"
                      v-model="varientDiscountPricing"
                    />

                    <div
                      class="absolute absset cursor-pointer"
                      @click="isshowDiscount = true"
                    >
                      <small class="fsize10 bg-white font-semibold text-primary"
                        >Add Discount</small
                      >
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-3 mt-4" v-if="isshowDiscount">
                  <div class="relative">
                    <small class="fsize10 text-dark">Pricing</small>
                    <el-input
                      placeholder="Pricing"
                      class="rounded-xl mt-2"
                      v-model="varientPricing"
                    />
                  </div>
                  <div class="relative">
                    <small class="fsize10 text-dark">Discount Pricing</small>
                    <el-input
                      placeholder="Eg:10%"
                      class="rounded-xl mt-2"
                      v-model="varientDiscountPercentage"
                    />

                    <!-- <div class="absolute absetdel mr-2 cursor-pointer">
                      <feather-icon
                        svgClasses="w-5 h-5"
                        class="text-8f8f8f"
                        icon="Trash2Icon"
                      />
                    </div> -->
                  </div>
                </div>
                <div class="mt-3 grid grid-cols-1 gap-3">
                  <div class="relative">
                    <small class="fsize10 text-dark">GST</small>
                    <el-input
                      placeholder="Enter GST"
                      class="rounded-xl mt-2"
                      v-model="varientGST"
                    />
                  </div>
                  <div class="relative">
                    <small class="fsize10 text-dark">SKU</small>
                    <el-input
                      placeholder="Enter SKU"
                      class="rounded-xl mt-2"
                      v-model="varientSKU"
                    />
                  </div>
                  <div class="relative">
                    <small class="fsize10 text-dark">HSN Code</small>
                    <el-input
                      placeholder="Enter HSN Code"
                      class="rounded-xl mt-2"
                      v-model="varientHSNCode"
                    />
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-3 mt-6">
                  <div class="relative">
                    <vs-button
                      variant="primary"
                      class="rounded-full bg-primary border-0 text-white font-medium fsize16 py-3 mt-3 w-full sm-fsize14"
                      @click="saveProduct()"
                    >
                      Save
                    </vs-button>
                  </div>
                  <div class="relative">
                    <vs-button
                      type="secondary"
                      class="rounded-full bg-secondary border-0 text-white font-medium fsize16 py-3 mt-3 w-full sm-fsize14"
                    >
                      Cancel
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-6">
            <el-collapse
              v-model="variant"
              class="cust-shadow mb-4 varcollapse-cs rounded-10px"
            >
              <el-collapse-item title="Variations-1" name="1">
                <div class="pt-2 px-4">
                  <div>
                    <small class="fsize12 font-semibold bg-white text-dark"
                      >Color</small
                    >
                    <div class="mt-1 flex gap-2">
                      <el-tag class="light-purplebgtext border-none fsize12"
                        >Yellow</el-tag
                      ><el-tag class="light-purplebgtext border-none fsize12"
                        >Pink</el-tag
                      >
                    </div>
                  </div>
                  <div class="mt-4">
                    <small class="fsize12 font-semibold bg-white text-dark"
                      >Size</small
                    >
                    <div class="mt-1 flex gap-2">
                      <el-tag class="light-bordertx fsize12">XL</el-tag>
                    </div>
                  </div>
                  <div class="mt-4 flex items-center gap-6 grid-cols-2">
                    <div class="w-full">
                      <small class="fsize12 font-semibold bg-white text-dark"
                        >Price</small
                      >
                      <div class="mt-1 flex gap-2">
                        <el-tag class="w-full light-bordertx fsize12"
                          >₹ 100
                          <span class="text-cross line-through">₹ 90</span
                          ><span class="text-success pl-2">(18% off)</span>
                        </el-tag>
                      </div>
                    </div>
                    <div class="w-full">
                      <small class="fsize12 font-semibold bg-white text-dark"
                        >GST</small
                      >
                      <div class="mt-1 flex gap-2">
                        <el-tag class="w-full light-bordertx fsize12"
                          >18% off
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-4 mt-8">
                    <button
                      class="flex filledtab rounded-full py-3 justify-center items-center"
                    >
                      <feather-icon icon="Edit2Icon" svgClasses="w-4 h-4" />
                      <p class="font-medium pl-2 mb-0">Edit</p>
                    </button>
                    <button
                      class="flex outlineborder rounded-full py-3 justify-center items-center"
                    >
                      <feather-icon icon="Trash2Icon" svgClasses="w-4 h-4" />
                      <p class="font-medium pl-2 mb-0">Delete</p>
                    </button>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <el-collapse
              v-model="variants"
              class="cust-shadow varcollapse-cs rounded-10px"
            >
              <el-collapse-item title="Variations-2" name="1">
                <div class="pt-2 px-4">
                  <div>
                    <small class="fsize12 font-semibold bg-white text-dark"
                      >Color</small
                    >
                    <div class="mt-1 flex gap-2">
                      <el-tag class="light-purplebgtext border-none fsize12"
                        >Yellow</el-tag
                      ><el-tag class="light-purplebgtext border-none fsize12"
                        >Pink</el-tag
                      >
                    </div>
                  </div>
                  <div class="mt-4">
                    <small class="fsize12 font-semibold bg-white text-dark"
                      >Size</small
                    >
                    <div class="mt-1 flex gap-2">
                      <el-tag class="light-bordertx fsize12">XL</el-tag>
                    </div>
                  </div>

                  <div class="mt-4 flex items-center gap-6 grid-cols-2">
                    <div class="w-full">
                      <small class="fsize12 font-semibold bg-white text-dark"
                        >Price</small
                      >
                      <div class="mt-1 flex gap-2">
                        <el-tag class="w-full light-bordertx fsize12"
                          >₹ 100
                          <span class="text-cross line-through">₹ 90</span
                          ><span class="text-success pl-2">(18% off)</span>
                        </el-tag>
                      </div>
                    </div>

                    <div class="w-full">
                      <small class="fsize12 font-semibold bg-white text-dark"
                        >GST</small
                      >
                      <div class="mt-1 flex gap-2">
                        <el-tag class="w-full light-bordertx fsize12"
                          >18% off
                        </el-tag>
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-2 gap-4 mt-8">
                    <button
                      class="flex filledtab rounded-4px py-2 justify-center items-center"
                    >
                      <feather-icon icon="Edit2Icon" svgClasses="w-4 h-4" />
                      <p class="font-medium pl-2 mb-0">Edit</p>
                    </button>

                    <button
                      class="flex outlineborder rounded-4px py-2 justify-center items-center"
                    >
                      <feather-icon icon="Trash2Icon" svgClasses="w-4 h-4" />
                      <p class="font-medium pl-2 mb-0">Delete</p>
                    </button>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isshowDiscount: false,
      ishowvariant: true,
      activeNames: ["1"],
      variant: ["1"],
      productName: "",
      tagName: null,
      productDescription: "",
      primaryAttribute: null,
      secondaryAttributes: null,
      primaryAttributeValue: null,
      attributeVal: [],
      showAttributeValue: false,
      datavalue: [],
      attributeValueImage: {},
      renderedmultipleImage: [],
      varientPricing: "",
      varientDiscountPricing: "",
      varientGST: "",
      varientSKU: "",
      varientHSNCode: "",
      varientDiscountPercentage: "",
      attributessizeOptions: [
        {
          value: "XL",
          label: "XL",
        },
        {
          value: "LG",
          label: "LG",
        },
      ],
      attributesOptions: [
        {
          value: "Color",
          label: "Color",
        },
        {
          value: "Size",
          label: "Size",
        },
      ],
      value1: [],
      value2: [],
      Attribute2: [],
      tagOptions: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],

      categoryptions: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],

      subcategoryOptions: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],
      textarea2: "",
    };
  },
  methods: {
    // handleAttributeValue(attributeValue){
    //   console.log(attributeValue);
    // },
    loadData() {
      this.$store.dispatch("tags/getTags");
      this.$store.dispatch("EcomAttributes/getAttributes");
    },
    async addAttributeValuePrimary() {
      console.log(this.primaryAttributeValue);
      let payload = {
        attributeValue: this.primaryAttributeValue,
        attributeName: this.primaryAttribute,
      };
      await this.$store.dispatch("EcomAttributes/addAttributesValue", payload);
      let payload1 = {
        attributeName: this.primaryAttribute,
      };
      await this.$store.dispatch(
        "EcomAttributes/getSingleAttributesPrim",
        payload1
      );
      if (this.datavalue.length > 0) {
        let data = this.primaryAttributeValue.filter((x) => {
          if (this.datavalue.filter((y) => x != y.name).length) return true;
        });
        console.log(data);
        this.datavalue.push({
          name: data[0],
          images: [],
        });
      } else {
        this.datavalue.push({
          name: this.primaryAttributeValue[0],
          images: [],
        });

        console.log(this.datavalue, "jkhkh");
      }

      // for(let i = 0; i < this.primaryAttributeValue.length; i++){
      //   for(let j = 0; j < this.datavalue.length; j++){

      //   }
      // }
    },
    handleSubmit() {
      console.log(this.tagName);
      console.log(this.primaryAttribute);
      console.log(this.secondaryAttributes);
      console.log(this.primaryAttributeValue);
    },
    display() {
      console.log(this.datavalue);
    },
    imageUpload: async function (file, items) {
      console.log(file.target.files.length);
      let selectedFile = file.target.files;
      console.log(selectedFile);
      console.log(items);

      // if (this.datavalue.name ==  < 5) {
      this.datavalue.map((x) => {
        if (x.name == items && x.images.length < 5) {
          x.images.push(...selectedFile);
        } else if (x.name == items) {
          x.images.shift(...selectedFile);
        }
      });
      // this.datavalue.push({ name: items, images: selectedFile });
      // }
      //  else {
      // this.datavalue.images.shift(selectedFile);
      // }
      for (let i = 0; i < selectedFile.length; i++) {
        this.newHandlemultiple(selectedFile[i]);
      }
      console.log(this.datavalue);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // if (this.renderedmultipleImage.length < 5) {
        this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        // } else {
        //   this.$emit("load", this.renderedmultipleImage.shift({name:items,images: e.target.result}));
        // }
      };
      console.log(this.renderedmultipleImage);
      reader.readAsDataURL(rawFile);
    },
    getImages(rawFile) {
      return URL.createObjectURL(rawFile);
    },
    async addValue() {
      this.showAttributeValue = true;
      let payload1 = {
        name: this.primaryAttribute,
      };
      await this.$store.dispatch("EcomAttributes/addAttributes", payload1);
      let payload2 = {
        name: this.secondaryAttributes,
      };
      await this.$store.dispatch("EcomAttributes/addAttributes", payload2);

      let payload3 = {
        attributeName: this.primaryAttribute,
      };
      await this.$store.dispatch(
        "EcomAttributes/getSingleAttributesPrim",
        payload3
      );
      console.log(this.singleAttrinutesPrime);
    },
    async saveProduct() {
      const payload = new FormData();
      payload.append("productName", this.productName);
      payload.append("description", this.description);
      payload.append("tagId", this.tagName);
      payload.append("attributeId1", this.primaryAttribute);
      payload.append("attributeId2", this.secondaryAttributes);
      payload.append("gst", this.varientGST);
      payload.append("sku", this.varientSKU);
      payload.append("HSNCode", this.varientHSNCode);
      payload.append("actualPrice", this.varientPricing);
      this.datavalue.forEach((item, index) => {
        payload.append(`item[${index}][name]`, item.name);
        item.images.forEach((images, imagesIndex) => {
          payload.append(`item[${index}][images][${imagesIndex}]`, images);
        });
      });

      await this.$store.dispatch("EcomProduct/addProduct", payload);
      // const payload = {
      //   productName: this.productName,
      //   description: this.description,
      //   tagId: this.tagName,
      //   attributeId1: this.primaryAttribute,
      //   attributeId2: this.secondaryAttributes,
      //   actualPrice: this.varientPricing,
      //   gst: this.varientGST,
      //   sku: this.varientSKU,
      //   HSNCode: this.varientHSNCode,
      // }
    },
  },
  mounted() {
    this.loadData();
    // console.log(this.singleAttrinutesPrime);
  },
  computed: {
    ...mapState("tags", ["tagsDetails"]),
    ...mapState("EcomAttributes", [
      "EcomAttrinutes",
      "singleAttrinutesPrime",
      "singleAttrinutesSec",
    ]),
  },
};
</script>

<style scoped>
.topright {
  top: 6px;
  right: 10px;
}
</style>
